import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import SignLrrpModal from 'SignLrrpModal';
import IfiLrrpModal from '../phaseActionMenu/ifiLrrpModal.jsx';
import PhaseType from 'types/phase';
import TaskType from 'types/task';
import { updatePhaseTask } from 'actionCreators/phase';
import PhaseTask from './phase_task';
import isIfiPhase from '../ifiUtils';

export class SignLrrp extends PhaseTask {
  isDisabled = () => false

  onClick = () => {
    if (this.props.task.status === 'complete') {
      this.toggleStatus();
    } else {
      this.setState({ modalActive: true });
    }
  }

  renderChildren = () => {
    const { phase, task, user: { name, lead_cert_number } } = this.props;
    if (phase.type === 'Installation' && isIfiPhase(phase)) {
      return (<IfiLrrpModal
        phase={phase}
        taskSlug="sign_lrrp"
        active={this.state.modalActive}
        onClose={this.handleClose}
      />);
    }

    return (<SignLrrpModal
      phase={phase}
      userName={name}
      leadCertNumber={lead_cert_number}
      task={task}
      active={this.state.modalActive}
      completeTask={this.completeTask}
      onClose={this.handleClose}
    />);
  }
}

SignLrrp.propTypes = {
  phase: PhaseType.isRequired,
  task: TaskType.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
};


export const sign_lrrp = connect(() => state => ({
  user: state.user,
}), { updatePhaseTask })(SignLrrp);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/sign_lrrp.jsx